module.exports = __webpack_public_path__ + "static/media/boom.e15a9fb4.png";